export default __webpack_public_path__ + "static/media/ReceivedFileIcon.1b1ccc82.svg";